import { post } from './http';

export const add = async ({ articleNumber, quantity = 1 }) => {
  if (!quantity || isNaN(quantity) || parseFloat(quantity) <= 0) {
    throw 'Invalid quantity';
  }

  const response = await post('/api/offer/add', {
    articleNumber,
    quantity: parseFloat(quantity),
  });
  return response.json();
};